import util from "@bmp-vue/core/api/util";

const controller = "CadastroUnico";
export default Object.assign(
  {},
  util.GetCrud(controller, ["none"]),
  {
    DadosBasicos: function (documento, tipo) {
      const endpoint = tipo === "PF" ? "Pf" : "Pj";
      return util.Axios.Get(
        `${controller}/DadosBasico${endpoint}?documentoFederal=${documento}`
      );
    },
  },
  {
    DadosBasicoPf: function (documento) {
      return util.Axios.Get(
        controller + `/DadosBasicoPf?documentoFederal=${documento}`
      );
    },
  },
  {
    DadosBasicoPj: function (documento) {
      return util.Axios.Get(
        controller + `/DadosBasicoPj?documentoFederal=${documento}`
      );
    },
  },
  {
    Renda: function (documento, tipo) {
      const endpoint = tipo === "PF" ? "Pf" : "Pj";
      return util.Axios.Get(
        `${controller}/Renda${endpoint}?documentoFederal=${documento}`
      );
    },
  },

  {
    Imoveis: function (documento) {
      return util.Axios.Get(
        controller + `/Imoveis?documentoFederal=${documento}`
      );
    },
  },
  {
    Veiculos: function (documento) {
      return util.Axios.Get(
        controller + `/Veiculos?documentoFederal=${documento}`
      );
    },
  },
  {
    Emails: function (documento) {
      return util.Axios.Get(
        controller + `/Emails?documentoFederal=${documento}`
      );
    },
  },
  {
    Telefones: function (documento) {
      return util.Axios.Get(
        controller + `/Telefones?documentoFederal=${documento}`
      );
    },
  },
  {
    Enderecos: function (documento) {
      return util.Axios.Get(
        controller + `/Enderecos?documentoFederal=${documento}`
      );
    },
  },
  {
    Contatos: function (documento) {
      return util.Axios.Get(
        controller + `/Contatos?documentoFederal=${documento}`
      );
    },
  },
  {
    Atividade: function (documento, tipo) {
      const endpoint = tipo === "PF" ? "Pf" : "Pj";
      return util.Axios.Get(
        `${controller}/Atividade${endpoint}?documentoFederal=${documento}`
      );
    },
  },
  {
    Risco: function (documento, tipo) {
      const endpoint = tipo === "PF" ? "Pf" : "Pj";
      return util.Axios.Get(
        `${controller}/Risco${endpoint}?documentoFederal=${documento}`
      );
    },
  },
  {
    Socios: function (documento) {
      return util.Axios.Get(
        controller + `/Socios?documentoFederal=${documento}`
      );
    },
  },
  {
    Documentos: function (documento) {
      return util.Axios.Get(
        controller + `/Documentos?documentoFederal=${documento}`
      );
    },
  },
  {
    BaixarDocumento: function (documento) {
      return util.Axios.Post(
        controller + "/Documento/Baixar", 
        {
          origem: documento.origem,
          arquivo: documento.arquivoDownload
        },
        {
          responseType: 'blob'
        }
      );
    },
  },
  {
    Score: function (documento) {
      return util.Axios.Get(
        controller + `/Score?documentoFederal=${documento}`
      );
    },
  },
  {
    Contas: function (documento) {
      return util.Axios.Get(
        controller + `/Contas?documentoFederal=${documento}`
      );
    },
  },
);
